module.exports = __webpack_public_path__ + "static/media/darth-vader.9fd74298.png";